import axios from 'axios';
var api_URL= 'http://localhost:8809'
if (process.env.NODE_ENV === "development") {
  api_URL = 'https://apilottoclient.newworld.center'
}
else if (process.env.NODE_ENV === "production") {
  api_URL = 'https://apilottoclient.newworld.center'
}

// api_URL = 'https://apixgen.javisx.com:7002'
const instance = axios.create({
  baseURL: api_URL
});

const AUTH_TOKEN = "123"
instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;

export default instance;
